import Index from './Users'
import Form from './Form'
import EditHeading from './EditHeading'
import CreditNotes from './CreditNotes'
import CreditNotesHeading from './CreditNotesHeading'
import Notifications from './Notifications'
import NotificationsHeading from './NotificationsHeading'
import AccountUsersList from './account-users/AccountUsersList'
import AccountUsersHeading from './account-users/AccountUsersHeading'
import IndexHeading from './IndexHeading'
import AdminOverview from './AdminOverview'
import AccountUserForm from './account-users/AccountUserForm'
import AccountUserHeading from './account-users/AccountUserHeading'
import DriverForm from './DriverForm'
import DriverHeading from './DriverHeading'
import PendingUsers from './PendingUsers'
import PendingUsersHeading from './PendingUsersHeading'

export default {
  Form,
  EditHeading,
  CreditNotes,
  CreditNotesHeading,
  Notifications,
  NotificationsHeading,
  AccountUsersList,
  AccountUsersHeading,
  Index,
  IndexHeading,
  AdminOverview,
  AccountUserForm,
  AccountUserHeading,
  DriverForm,
  DriverHeading,
  PendingUsers,
  PendingUsersHeading
}



// WEBPACK FOOTER //
// ./src/components/user/index.js